// Copyright (c) 2016 Deere & Company

import {buildDealer} from './build-dealer';

export const addCollectionLabels = (collectionToLabel, labelByValue = null) => collectionToLabel
    .map(item => Object.assign({}, item, {label: (labelByValue ? item[labelByValue] : buildDealer(item))}));



// WEBPACK FOOTER //
// ./src/shared/services/add-collection-labels.js